export default __webpack_public_path__ + "static/media/best-colleges.5fad6ae1.jpg";